export enum Workloads {
  FullTime = 'Full-time',
  PartTime = 'Part-time',
  Both = 'Both',
}
